import * as React from 'react';
import * as ReactDom from 'react-dom';
import { RCUtils } from './../../RCUtils';

import forEach from 'lodash/forEach';
var Config: any = require('../../Config.json');

export interface CustomEditRendererState {
    isEditMode: boolean;
    isDisabled: any;
    CustomerGroups: any;
    Thirdparty: server.ThirdParty[];
    ThirdPartyAccess: any;
}


var self;
export class GridDropdownThirdPartyRenderer extends React.Component<any, CustomEditRendererState> {
    constructor(props: any) {
        super(props);

        this.state = {
            isEditMode: false,
            isDisabled: null,
            CustomerGroups: [],
            Thirdparty: this.props.colDef.cellRendererParams.refThirdParty,
            ThirdPartyAccess: props.value
        };
        
        self = this;
    }

   
    componentDidMount() {
        this.setState({ isDisabled: false });

    }
    setSaveButtonDisabled(flag) {
        this.setState({ isDisabled: flag });
    }

    cancelRowData(event: any) {

        this.props.onThirdPartyNameChange(event.target.value);
        this.setState({ ThirdPartyAccess: event.target.value });
        //setThirdPartyName(event.target.value);
    }

    componentWillReceiveProps(nextprops: any) {


    }
    ThirdPartyAccessChange(e) {

        var Value: string = e.currentTarget.value;
        this.setState({
            ThirdPartyAccess: Value
        });
        const thirdpartyUnits = this.state.Thirdparty.filter(obj => {
            return obj.ThirdPartyCd == Value;
        });
        const row = this.props.data;
        // var accCodes = [];
        // accCodes.push(thirdpartyUnits[0].ThirdPartyCd);
        if(Value=="-1")
        row.accessCodes="-1";
        else
        row.accessCodes = thirdpartyUnits[0].ThirdPartyCd;
    }

    public render() {
        return <div>
            <select className='form-select' id="cBoxThirdPartyAccess" name="ThirdPartyAccess" value={this.state.ThirdPartyAccess}
                onChange={e => this.ThirdPartyAccessChange(e)} >
                <option value="-1">---None---</option>
                {
                    this.state.Thirdparty.map((tP, index) =>
                        <option key={index} value={tP.ThirdPartyCd}>{tP.ThirdPartyName}</option>
                    )
                }
            </select>
        </div>;
    }
}
